export default "__VITE_ASSET__DHNiy7OA__"